export const GET_PAYMENT_OPTIONS = 'GET_PAYMENT_OPTIONS';
export const GET_PAYMENT_OPTIONS_SUCCEEDED = 'GET_PAYMENT_OPTIONS_SUCCEEDED';
export const GET_PAYMENT_OPTIONS_FAILED = 'GET_PAYMENT_OPTIONS_FAILED';

export const CONFIRM_PAYMENT = 'CONFIRM_PAYMENT';
export const CONFIRM_PAYMENT_SUCCEEDED = 'CONFIRM_PAYMENT_SUCCEEDED';
export const CONFIRM_PAYMENT_ERROR = 'CONFIRM_PAYMENT_ERROR';

export const CANCEL_PAYMENT = 'CANCEL_PAYMENT';
export const CHECK_PAYMENT_STATUS = 'CHECK_PAYMENT_STATUS';
export const UPDATE_PAYMENT_STATUS = 'UPDATE_PAYMENT_STATUS';

export const SET_PAYMENT_URL = 'SET_PAYMENT_URL';
